/**
 * In Typesense, the page title must be unique. To differentiate between different carousels and carousel tiles with the same name, extra information may be appended to the name.
 *
 * For example, "Lofi|Beats zone" will need splitting on `|` to extract "Lofi" as the name.
 */
export const parseCarouselName = (name: string): string =>
  name.split('|')[0].trim();
